<!-- Loader -->
<div id="app-loader" class="loader" [ngClass]="{ 'page-loader': pageLoader, 'mini-loader': miniLoader }">
    <span class="loader-spinner"></span>
</div>